/* RG CG1: storefront-only session boundary. Native Shopify checkout still needs
 * a server-side validation Function. No email lookup, pricing, order or payment writes.
 * Existing rg-commerce-isolation-0926.js exclusively owns cart-line cleanup. */
(function () {
  'use strict';
  var node = document.getElementById('RgCommerceEntryConfig'), cfg;
  try { cfg = JSON.parse(node.textContent); } catch (_) { return; }
  if (!cfg || cfg.version !== 'CG1' || cfg.designMode || window.RGCommerceEntryCG1) return;
  window.RGCommerceEntryCG1 = true;
  var root = String(cfg.root || '/');
  if (root[0] !== '/' || root.indexOf('//') === 0) return;
  root = root.replace(/\/?$/, '/');
  var messages = cfg.messages || {}, replay = new WeakSet(), busy = false;
  var seenKey = 'rg-cg1:' + String(cfg.themeId), resetKey = 'rg_b2b_reset';
  function msg(key) { return messages[key] || messages.failed || 'Please refresh the page and try again.'; }
  function url(path) {
    var u = new URL(root + path, location.origin);
    if (cfg.preview && /^\d+$/.test(String(cfg.themeId))) u.searchParams.set('preview_theme_id', String(cfg.themeId));
    return u;
  }
  function catalogUrl() {
    var u = new URL(cfg.catalogUrl || root + 'collections/sonbahar-kis', location.origin);
    if (u.origin !== location.origin) return url('collections/sonbahar-kis');
    if (cfg.preview) u.searchParams.set('preview_theme_id', String(cfg.themeId));
    return u;
  }
  function currentPath() { return location.pathname.replace(/\/$/, ''); }
  function relativePath() { return location.pathname.slice(root.length).replace(/\/$/, ''); }
  function legalOrAccountAction() {
    var p = relativePath();
    return /^policies\//.test(p) || /(?:logout|recover|reset|activate)/.test(p) ||
      (p.indexOf('pages/') === 0 && p !== 'pages/b2b') ||
      (p === 'cart' && new URL(location.href).searchParams.get('view') === 'rg-b2b-offline');
  }
  function notice(text, label, destination, focus) {
    if (!document.body) {
      document.addEventListener('DOMContentLoaded', function () { notice(text, label, destination, focus); }, {once:true});
      return;
    }
    var box = document.getElementById('RgCommerceEntryNotice');
    if (!box) {
      box = document.createElement('aside'); box.id = 'RgCommerceEntryNotice';
      box.className = 'rg-isolation-notice rg-commerce-entry-notice';
      box.setAttribute('role', 'status'); box.setAttribute('aria-live', 'polite'); box.tabIndex = -1;
      var p = document.createElement('p'), a = document.createElement('a');
      p.dataset.rgEntryText = ''; a.dataset.rgEntryLink = ''; a.className = 'button button--outlined';
      box.append(p, a); (document.getElementById('MainContent') || document.body).prepend(box);
    }
    box.querySelector('[data-rg-entry-text]').textContent = text;
    var link = box.querySelector('[data-rg-entry-link]');
    link.hidden = !destination; link.textContent = label || '';
    if (destination) link.href = destination.toString();
    if (focus) box.focus({preventScroll:false});
  }
  function accountUrl() { return new URL('/customer_authentication/login?return_to=' + encodeURIComponent(root + 'pages/b2b'), location.origin); }
  function stop(event) { event.preventDefault(); event.stopImmediatePropagation(); }
  function checkoutTarget(target) {
    if (!target) return false;
    if (target.name === 'checkout' || target.matches('[data-rg-b2b-start-checkout],[data-rg-b2b-finalize]')) return true;
    if (target.tagName !== 'A') return false;
    try { var u = new URL(target.href, location.href); return u.origin === location.origin && /\/checkouts?(?:\/|$)/.test(u.pathname); }
    catch (_) { return false; }
  }
  function checkoutForm(form, submitter) {
    if (checkoutTarget(submitter)) return true;
    try {
      var u = new URL(form.action, location.href);
      if (u.origin !== location.origin) return false;
      return /\/checkouts?(?:\/|$)/.test(u.pathname) || (!submitter && form.matches('#cart,#CartDrawer-FormSummary'));
    } catch (_) { return false; }
  }
  async function readState() {
    var u = url('cart'); u.searchParams.set('view', 'rg-commerce-state-1310'); u.searchParams.set('_rg', String(Date.now()));
    var abort = new AbortController(), timer = setTimeout(function () { abort.abort(); }, 8000);
    try {
      var response = await fetch(u.toString(), {credentials:'same-origin',cache:'no-store',signal:abort.signal,headers:{Accept:'text/html'}});
      if (!response.ok) throw Error(msg('failed'));
      var state = await response.json();
      if (!state || state.version !== 'CG1' || ['authenticated','b2b','ready','hasRetail','hasPacks'].some(function(k){ return typeof state[k] !== 'boolean'; })) throw Error(msg('failed'));
      return state;
    } finally { clearTimeout(timer); }
  }
  function changed(state) {
    return state.authenticated !== cfg.authenticated || state.b2b !== cfg.b2b || state.ready !== cfg.ready ||
      String(state.customerKey || '') !== String(cfg.customerKey || '') || String(state.locationKey || '') !== String(cfg.locationKey || '');
  }
  function replayEvent(target, form, kind) {
    replay.add(target); if (form) replay.add(form);
    try {
      if (kind === 'click') target.click();
      else if (typeof form.requestSubmit === 'function') form.requestSubmit(target === form ? undefined : target);
      else notice(msg('failed'), msg('cart'), url('cart'), true);
    } finally { replay.delete(target); if (form) replay.delete(form); }
  }
  async function guard(event, target, form, kind) {
    stop(event);
    if (busy || window.RGB2BCartOperationPending || window.RGB2BCheckoutPending) {
      notice(msg('wait'), '', null, true); return;
    }
    if (form && !form.reportValidity()) return;
    busy = true;
    target.setAttribute('aria-busy', 'true');
    try {
      var state = await readState();
      if (window.RGB2BCartOperationPending || window.RGB2BCartNeedsReview || window.RGB2BCheckoutPending) throw Error(msg('wait'));
      if (changed(state)) {
        notice(msg('changed'), msg('cart'), url('cart'), true);
        location.replace(url('cart').toString()); return;
      }
      if (state.b2b && !state.ready) { notice(msg('company'), msg('account'), accountUrl(), true); return; }
      if (state.b2b && state.hasRetail) {
        var cartUrl = url('cart'); cartUrl.searchParams.set(resetKey, '1'); location.replace(cartUrl.toString()); return;
      }
      if (!state.b2b && state.hasPacks) { notice(msg('retailHold'), msg('cart'), url('cart'), true); return; }
      if (state.b2b && !target.matches('[data-rg-b2b-start-checkout],[data-rg-b2b-finalize]')) {
        var offline = url('cart'); offline.searchParams.set('view','rg-b2b-offline'); location.assign(offline.toString()); return;
      }
      busy = false;
      replayEvent(target, form, kind);
    } catch (_) { notice(msg('failed'), msg('cart'), url('cart'), true); }
    finally { busy = false; target.removeAttribute('aria-busy'); }
  }
  // Window capture precedes the theme's existing document-capture handlers.
  window.addEventListener('click', function (event) {
    var target = event.target instanceof Element ? event.target.closest('button,a,input') : null;
    if (cfg.b2b !== true || !checkoutTarget(target) || replay.has(target)) return;
    guard(event, target, target.form || target.closest('form'), 'click');
  }, true);
  window.addEventListener('submit', function (event) {
    var form = event.target;
    if (cfg.b2b !== true || !(form instanceof HTMLFormElement) || replay.has(form) || replay.has(event.submitter) || !checkoutForm(form, event.submitter)) return;
    guard(event, event.submitter || form, form, 'submit');
  }, true);
  function ready() {
    if (!cfg.authenticated || !cfg.b2b) return;
    if (!cfg.ready) { notice(msg('company'), msg('account'), accountUrl(), false); return; }
    var current = new URL(location.href);
    if (cfg.hasRetail) {
      current.searchParams.set(resetKey, '1');
      try { history.replaceState(history.state, '', current.toString()); } catch (_) {}
      return;
    }
    if (window.RGB2BCartOperationPending || window.RGB2BCartNeedsReview) return;
    var p = relativePath(), catalog = catalogUrl();
    if (current.searchParams.has(resetKey)) {
      current.searchParams.delete(resetKey);
      try { history.replaceState(history.state, '', current.toString()); } catch (_) {}
    }
    if (legalOrAccountAction()) return;
    if ((p === 'account') && currentPath() !== catalog.pathname.replace(/\/$/, '')) {
      location.replace(catalog.toString());
    }
  }
  window.addEventListener('rg:retail-clean', function () { cfg.hasRetail = false; ready(); });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', ready, {once:true}); else ready();
})();
